import type { CopyShape } from "@tami/core/intl";

import type { WEB_ERRORS_COPY_PT_BR } from "../web-errors.copy";

export const WEB_ERRORS_COPY_ES_ES: CopyShape<typeof WEB_ERRORS_COPY_PT_BR> = {
  unexpected: "Ha ocurrido un error inesperado. Vuelve a intentarlo.",
  sessionNotFound: "Sesión no encontrada",
  sessionNotFoundDot: "Sesión no encontrada.",
  passwordVerifyFailed: "No hemos podido verificar la contraseña",
  sessionRenewFailed: "No hemos podido renovar la sesión.",
  signUpFailed: "Error al completar el registro",
  uploadImageFailed: "No hemos podido subir la imagen.",
  uploadImageFailedRetry: "No hemos podido subir la imagen. Vuelve a intentarlo.",
  roteiroLoadFailed: "No hemos podido cargar el guion. Vuelve a intentarlo.",
  invalidDate: "Fecha no válida",
  collabNoAccess: "No tienes acceso a este contenido del creator.",
  widget: {
    title: "Algo ha fallado",
    description: "No hemos podido cargar la información.",
    retry: "Reintentar",
  },
};
